import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import sort from "../../assets/images/devlisting/Frame.svg";
import filtericon from "../../assets/images/devlisting/filter-icon.svg";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import FilterPopup from "../popup/filterpopup";

const CategoryListing = () => {
  const [active, setActive] = useState("");
  const handleclick = (name) => {
    setActive(name);
  };
  const [filter, setFilter] = useState(false);
  const handleClose = () => {
    setFilter(false);
  };
  const handleShow = () => {
    setFilter(true);
  };
  console.log("active---->", active);
  const categoryList = [
    {
      category: "Latest First",
    },
    {
      category: "High Rated",
    },
    {
      category: "Lorem",
    },
  ];
  return (
    <div className="category-content">
      <div className="category-content-list">
        {categoryList.map((e, i) => (
          <span
            className={active === e?.category ? "active" : ""}
            key={i}
            onClick={() => handleclick(e.category)}
          >
            {e.category}
          </span>
        ))}
        <div className="category-content-dropdown">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">Sort by</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="category-content-list-mobile">
        <Button className="filter-btn" onClick={handleShow}>
          <img src={filtericon} alt="filter" />
          Filters
        </Button>
        <div className="category-content-dropdown">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <img src={sort} alt="sort" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">
                <div className="category-item">
                  <span for="test1">Default</span>
                  <input type="radio" id="test1" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item href="#/action-2">
                <div className="category-item">
                  <span for="test2">First Name</span>
                  <input type="radio" id="test2" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item href="#/action-3">
                <div className="category-item">
                  <span for="test3">Last Name</span>
                  <input type="radio" id="test3" />
                </div>
              </Dropdown.Item>
              <Dropdown.Item href="#/action-4">
                <div className="category-item">
                  <span for="test4">Lorem Ipsum</span>
                  <input type="radio" id="test4" />
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <Modal
        show={filter}
        onHide={handleClose}
        centered
        className="filter-popup"
      >
        <Modal.Body>
          <FilterPopup handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CategoryListing;
